import React from "react";
import { startCase } from "lodash";
import { Tag } from "@chakra-ui/react";
import { SessionStatus } from "types";

interface Props {
  status: SessionStatus | string;
}

const StatusTag: React.FC<Props> = ({ status }: Props) => {
  const tagColor = () => {
    switch (status) {
      case SessionStatus.Completed:
        return "green";
      case SessionStatus.Cancelled:
      case SessionStatus.NoShow:
        return "red";
      case SessionStatus.Scheduled:
      default:
        return "gray";
    }
  };

  return (
    <Tag
      variant="subtle"
      colorScheme={tagColor()}
      size="md"
      width="fit-content"
    >
      {startCase(status)}
    </Tag>
  );
};

export default StatusTag;
